import { render, staticRenderFns } from "./VerificationsByType.vue?vue&type=template&id=4337ede4&scoped=true"
import script from "./VerificationsByType.vue?vue&type=script&lang=js"
export * from "./VerificationsByType.vue?vue&type=script&lang=js"
import style0 from "./VerificationsByType.vue?vue&type=style&index=0&id=4337ede4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4337ede4",
  null
  
)

export default component.exports